<div nxLayout="grid maxwidth" class="employees">
  <div nxRow>
    <div nxCol="12">
      <nx-link class="go-back">
        <a routerLink="../">
          <nx-icon name='chevron-left'></nx-icon>
          {{'policy.employees.go-back' | translate}}
        </a>
      </nx-link>
    </div>
  </div>
  <div nxRow>
    <div nxCol="12">
      <nx-card>
        <nx-card-header>
          <h3 nxHeadline="subsection-medium" translate class="title">
            policy.employees.title</h3>
        </nx-card-header>
        <div class="employees-content">
          <div nxRow>
            <div nxCol="12">
              <div class="employees-actions">
                <form [formGroup]="form" autocomplete="off">
                  <nx-formfield
                    label="{{ 'policy.employees.data.surname' | translate }}">
                    <input nxInput formControlName="surname" type="text" />
                  </nx-formfield>

                  <nx-formfield
                    label="{{ 'policy.employees.data.name' | translate }}">
                    <input nxInput formControlName="name" type="text" />
                  </nx-formfield>

                  <nx-formfield
                    label="{{ 'policy.employees.data.birth-date' | translate }}"
                    class="datepicker">
                    <input nxInput formControlName="dateOfBirth" type="text" />
                  </nx-formfield>

                  <cpc-button size="x-small" [noHorizontalMargin]="true"
                    [noVerticalMargin]="true" (click)="useFilter()"><span
                      translate>policy.employees.use-filter-btn</span>
                  </cpc-button>
                  <cpc-button mode="secondary" size="x-small"
                    [noHorizontalMargin]="true" [noVerticalMargin]="true"
                    (click)="clearFilter()"><span
                      translate>policy.employees.clear-filter-btn</span>
                  </cpc-button>
                </form>

                <div class="trip-actions__new">
                  <cpc-button size="small-medium" (click)="addEmployee()"
                    [noHorizontalMargin]="true" [noVerticalMargin]="true"><span
                      translate>policy.employees.new-employee-btn</span>
                  </cpc-button>
                </div>
              </div>
            </div>
          </div>
          <div nxRow>
            <div nxCol="12">
              <!-- check swipebar module -->
              <table nxTable>
                <thead>
                  <tr nxTableRow>
                    <th nxHeaderCell>
                      {{ 'policy.employees.data.surname' | translate }}
                    </th>
                    <th nxHeaderCell>
                      {{ 'policy.employees.data.name' | translate }}
                    </th>
                    <th nxHeaderCell>
                      {{ 'policy.employees.data.birth-date' | translate }}
                    </th>
                    <th nxHeaderCell>
                      {{ 'policy.employees.data.end-employment' | translate }}
                    </th>
                    <!-- TODO REMOVE? -->
                    <!--
                    <th nxHeaderCell>
                      {{ 'policy.employees.data.email' | translate }}
                    </th>
                    <th nxHeaderCell>
                      {{ 'policy.employees.data.department' | translate }}
                    </th>-->
                    <th nxHeaderCell>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr nxTableRow *ngFor="let item of pageTableData">
                    <td nxTableCell>{{item.surname}}</td>
                    <td nxTableCell>{{item.name}}</td>
                    <td nxTableCell>{{item.dateOfBirth|dateFormat}}</td>
                    <td nxTableCell>{{item.canceledDate|dateFormat}}</td>
                    <!-- TODO REMOVE? -->
                    <!--<td nxTableCell>{{item.email}}</td>-->
                    <!--<td nxTableCell>{{item.department}}</td>-->
                    <!-- TODO update after real data -->
                    <td nxTableCell>
                      <a (click)="editEmployee(item.id)">
                        <cpc-icon icon='edit' color="#007ab3"
                          style="font-size: 20px"></cpc-icon>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div nxRow>
            <div nxCol="12">
              <cpc-pagination [page]='activePage' [variant]="variant"
                [maxPage]='maxPage' [itemsPerPage]='itemsPerPage'
                (changePage)='handleChangePage($event)'></cpc-pagination>
            </div>
          </div>
        </div>
      </nx-card>
    </div>
  </div>
</div>
